// extracted by mini-css-extract-plugin
module.exports = {"timer":"Timer_timer__RB9b3","unit_wrapper":"Timer_unit_wrapper__12ujk","unit_type":"Timer_unit_type__3EqJb","mini":"Timer_mini__20EdO","medium":"Timer_medium__1JqYE"};